import Modal from 'flarum/common/components/Modal';
import LoadingIndicator from "flarum/common/components/LoadingIndicator";

// iframe 入口标记改从共享模块取 (js/src/common/helpers/
// zivenCoreAdminFrame.js) —— 之前这里和 admin 侧各写死一份 'ziven-core-r15',
// 改一处不改另一处会**静默失效** (不报错、不白屏, 只是后台定制不生效)。
import { IFRAME_MARKER } from '../../common/helpers/zivenCoreAdminFrame';

// ── 后台弹窗 (iframe 直开) ───────────────────────────────────────────
//
// 这个弹窗现在**只做一件事**: 把 `/admin?_iframe=...` 塞进 iframe 里直开。
// 不探测、不轮询、不兜底按钮。
//
// ⚠️ 为什么当初加过「白屏探测 + 兜底按钮」, 为什么现在又删掉:
//   历史上这套东西是这么运作的: 每 200ms 读一次 iframe 的 `contentDocument`,
//   看后台导航 (`.AdminNav`) 渲染出来没有; 5 秒内没有就显示一个
//   「在新标签打开后台」的 <a target="_blank">, 等探测到了再把按钮撤回。
//   设计初衷是好的 —— 面板万一白屏, 至少给用户留一条逃生通道。
//
//   但**生产实测把这套阈值直接打穿了**:
//   bjxy.top 后台面板冷启动要 **16.9 秒** (实测 16914ms) 才渲染出 `.AdminNav`,
//   而阈值只有 5 秒 ⇒ **每一次正常打开**, 这个按钮都必然先冒头约 12 秒再消失
//   ⇒ 对正常用户来说它不是「逃生通道」, 而是**每次都出现的噪音**。
//
//   ⇒ 辉哥 2026-10-23 拍板:「通过 iframe 打开的后台管理, 不要加在新窗口打开的那个按钮」
//   ⇒ 本次把按钮 + 只服务于它的探测/定时器/state 一并删干净 (别留死代码)。
//
// ⛔ 将来想把这个探测加回来, 先想清楚这三件事 (任一不成立就别加):
//   1) 阈值得盖得住实测冷启动 (>= 17s) —— 但那样「白屏」要等 17 秒才提示, 更糟;
//   2) 判据得是可靠的布尔信号 —— 实测「正文长度 / 可见文本长度」这类数字阈值不可用
//      (同一个「成功态」在不同上下文里能差 46.7 倍), 只有「导航渲染出来没有」稳定;
//   3) 得先问过辉哥 ——「正常路径也允许挂一个按钮」这件事他明确不答应。
//
// ⚠️ 已知边界: iframe 里真出 403 / 白屏时, **没有**「新标签」逃生口了,
//   只能关掉弹窗重进 (顶层直接访问 `/admin` 不受影响, 详见 CHANGELOG.md)。

export default class adminPanelModal extends Modal {
  className() {
    return 'Modal--large AdminPanelModal';
  }
  title() {
    return m("div", null, app.translator.trans('ziven-community-core.forum.admin-panel'));
  }
  content() {
    // app.forum.attribute('adminUrl')
    return (
      // ⚠️ 这个根 div 必须带自己的 class (.AdminPanelModal-inner):
      //   手机端要让 iframe 填满 modal, 得靠「.Modal-content → 这个 div → .Modal-body」
      //   这条 flex 链把高度一路传下去。
      //   ⛔ **不能**用 `.Modal-content > div` 来定位它 —— .Modal-content 的第一个
      //     子 div 是核心的关闭按钮 (.Modal-close.App-backControl), 会选错。
      //   ⛔ **不能**只给 iframe 挂 height:100% —— .Modal-body 的父级是这个裸 div
      //     (不是 .Modal-content), flex 落不到它身上, 百分比高度解不出来 ⇒ iframe 塌成 150px。
      m("div", {
        className: "AdminPanelModal-inner"
      }, m("div", {
        className: "Modal-body"
      }, m("iframe", {
        id: "adminPanelIframe",
        src: "/admin?_iframe=".concat(IFRAME_MARKER)
      })))
    );
  }
}
flarum.reg.add('ziiven-ziven-core', 'forum/modal/adminPanelModal', adminPanelModal);